import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-post-reset-instructions-dialog',
  templateUrl: './post-reset-instructions-dialog.component.html',
  styleUrls: ['./post-reset-instructions-dialog.component.scss']
})
export class PostResetInstructionsDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
